exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".listContainer[data-v-4032aca3]{display:flex;flex-wrap:wrap;font-family:Roboto,sans-serif;width:100%;justify-content:center}.videoItem[data-v-4032aca3]:hover{cursor:pointer}.videoItem[data-v-4032aca3]{width:200px;height:200px;margin:10px;display:flex;align-items:center;text-align:center;justify-content:center;font-size:20px;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4032aca3","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/assets/Dynamic/app/videos_insanity/listOfVideos.vue
// module id = 629
// module chunks = 0